import videojs from 'video.js';
import vjsSrv from 'src/js/services/vjsSrv';

let bigBtnClick = false;
let playToggleClick = false;
const BigPlayButton = videojs.getComponent('BigPlayButton');
let BigPlayBtn = videojs.extend(BigPlayButton, {
  constructor: function() {
    BigPlayButton.apply(this, arguments);
  },
  handleClick: function(event) {
    bigBtnClick = true;
    const state = this.player().paused() ? 'playing' : 'paused';
    vjsSrv.onPlayBntClick(event, 'BigPlayButton', state);
    BigPlayButton.prototype.handleClick.call(this, event);
  }
});

const PlayToggle = videojs.getComponent('PlayToggle');
let PlayToggleBtn = videojs.extend(PlayToggle, {
  constructor: function() {
    PlayToggle.apply(this, arguments);
  },
  handleClick: function(event) {
    playToggleClick = true;
    const state = this.player().paused() ? 'playing' : 'paused';
    vjsSrv.onPlayBntClick(event, 'PlayToggle', state);
    // PlayToggle.prototype.handleClick.call(this, event);
  }
});

let ClickableComponent = videojs.getComponent('ClickableComponent');
let WrapperBigPlayBtn = videojs.extend(ClickableComponent, {
  constructor: function() {
    ClickableComponent.apply(this, arguments);
    this.addChild('BigPlayBtn');
  },
  createEl: function(...args) {
    let wrapper = videojs.dom.createEl('div', {
      className: 'vjs-big-play-button-block'
    }, {
      readonly: true
    });
    wrapper.addEventListener('touchstart', (event) => {
      this.player().userActive(true);
    });
    return wrapper;
  },
  buildCSSClass: function buildCSSClass() {
    return 'vjs-big-play-button-block';
  },
  handleClick: function(event) {
    if (!bigBtnClick) {
      bigBtnClick = false;
      const state = this.player().paused() ? 'playing' : 'paused';
      vjsSrv.onPlayBntWrapperClick(event, state);
    }
    bigBtnClick = false;
  }
});

videojs.registerComponent('PlayToggleBtn', PlayToggleBtn);
videojs.registerComponent('BigPlayBtn', BigPlayBtn);
videojs.registerComponent('WrapperBigPlayBtn', WrapperBigPlayBtn);